import React, { useState } from "react";
import Essentials from "./Essentials";
import NonEssentials from "./NonEssentials";
import SolarCalculatorFunctionalities from "../../utills/SolarCalculatorFunctionalities";

const MyAppliances = ({
  appliances,
  handleInputChange,
  handleAddAppliancesField,
  calculateSolarRecommendation,
  handleRemoveInputField,
  location,
}) => {
  const [essentialLoads, setEssentialLoads] = useState("essentials");
  return (
    <>
      <div className="p-4 ">
        <div className="flex justify-center">
          <button
            className={`w-fit rounded-t-md p-1.5 text-white ${
              essentialLoads === "essentials" ? "bg-error" : ""
            }`}
            onClick={() => setEssentialLoads("essentials")}
          >
            Essential Loads
          </button>
          <button
            className={`w-fit rounded-t-md p-1.5 text-white ${
              essentialLoads === "non-essentials" ? "bg-error " : ""
            }`}
            onClick={() => {
              setEssentialLoads("non-essentials");
            }}
          >
            Non-Essential Loads
          </button>
        </div>
        <form onSubmit={(e) => calculateSolarRecommendation(e, appliances)}>
          {essentialLoads === "essentials" && (
            <Essentials
              appliances={appliances}
              handleInputChange={handleInputChange}
              handleAddAppliancesField={handleAddAppliancesField}
              handleRemoveInputField={handleRemoveInputField}
            />
          )}

          {essentialLoads === "non-essentials" && (
            <NonEssentials
              appliances={appliances}
              handleInputChange={handleInputChange}
              handleAddAppliancesField={handleAddAppliancesField}
              handleRemoveInputField={handleRemoveInputField}
            />
          )}

          <div className="border border-neutral flex flex-col gap-2 rounded mt-5 p-5 ">
            <label className="block text-base font-medium text-white">
              Location Sun Exposure
            </label>
            <select
              value={location || ""}
              onChange={(e) =>
                handleInputChange(null, null, "location", e.target.value)
              }
              className="mt-1 block w-full text-black rounded-md border-neutral shadow-sm focus:border-error focus:ring-error p-2 border"
            >
              <option value="high">
                High (e.g., Rajasthan, Gujarat, Tamil Nadu)
              </option>
              <option value="medium">
                Medium (e.g., Maharashtra, Karnataka, Andhra Pradesh)
              </option>
              <option value="low">
                Low (e.g., Kerala, Northeast India, Himachal Pradesh)
              </option>
            </select>
          </div>

          <div className="text-center mt-5 ">
            <button
              className="bg-white text-black hover:bg-error hover:text-white p-1.5 rounded text-center mx-auto"
              type="submit"
            >
              Calculate My Savings
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default MyAppliances;
